import { notFound } from "@tanstack/react-router";
import { requireSiteAdmission } from "@/features/game/data";
import { buildHref } from "@softmax/web-addresses";
import {
  browseCatalog,
  browseLeaderboard,
  browseThumbnails,
} from "./browse.data";

export async function getBrowseCatalog({
  href,
  signal,
}: {
  href: string;
  signal?: AbortSignal | undefined;
}) {
  const url = new URL(href, window.location.origin);

  if (url.pathname !== buildHref({ name: "browse" })) throw notFound();

  await requireSiteAdmission({ href, game: null, signal });
  return browseCatalog(url.searchParams.get("cursor"), signal);
}

export function getBrowseLeaderboard({
  leagueId,
  signal,
}: {
  leagueId: string;
  signal?: AbortSignal | undefined;
}) {
  return browseLeaderboard(leagueId, signal);
}

export function getBrowseThumbnails({
  leagueIds,
  signal,
}: {
  leagueIds: string[];
  signal?: AbortSignal | undefined;
}) {
  return browseThumbnails(leagueIds, signal);
}
